import { useSelector, useDispatch } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { useEffect } from "react";
import uniqueBnDevSlice, { graphUniqueBnDev, SelectUniqueBrowsers, SelectgraphUniqueBnDevStatus, SelectWeeks, SelectUniqueEngaged, setUniqueEngaged } from "./uniqueBnDevSlice";
import { NumberOfUniqueVisitorsGraph } from "../../../../components/Graphs/graphs";
import { SelectPercentVisitors, SelectWeeks as SelectSessionDistributionWeeks } from "../SessionDistribution/sessionDistributionSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";



const UniqueBnDev = ({ display }) => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];
  
  // const UniqueBnDevData = useSelector(state => state.uniqueBnDev)
  const loading = useSelector(SelectgraphUniqueBnDevStatus);
  const uniqueBrowsers = useSelector(SelectUniqueBrowsers);
  const uniqueEngaged = useSelector(SelectUniqueEngaged);
  const weeks = useSelector(SelectWeeks);
  const percentVisitors = useSelector(SelectPercentVisitors)
  const sessionDistributionWeeks = useSelector(SelectSessionDistributionWeeks)
  console.log('percentVisitors in UniqueBnDev:', percentVisitors);
  console.log('uniqueBrowsers in UniqueBnDev:', uniqueBrowsers);
  
  useEffect(() => {
    if (!user) return null
    if(weeks.length===0) dispatch(graphUniqueBnDev(user))
  }, [user, weeks])


  useEffect(() => {
    if (
      percentVisitors.length === 0 ||
      uniqueBrowsers.length === 0 ||
      weeks.length === 0
    ) return;

    const normalizeWeekKey = (weekValue) => {
      const raw = String(weekValue ?? "").trim();
      if (!raw) return "";

      const parsedDate = new Date(raw.replace(/\//g, "-"));
      if (Number.isNaN(parsedDate.getTime())) return raw;

      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
      const day = String(parsedDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    // Build key-value mapping so each week's engaged value stays on the same date.
    const percentVisitorsByWeek = {};
    sessionDistributionWeeks.forEach((week, index) => {
      const key = normalizeWeekKey(week);
      const percentValue = Array.isArray(percentVisitors[index])
        ? percentVisitors[index][0]
        : percentVisitors[index];

      percentVisitorsByWeek[key] = Number(percentValue) || 0;
    });

    const engagedArray = weeks.map((week, index) => {
      const key = normalizeWeekKey(week);
      const percent = percentVisitorsByWeek[key] || 0;
      const totalUsers = Number(uniqueBrowsers[index]) || 0;
      return Math.round(totalUsers * (percent / 100));
    });

    dispatch(setUniqueEngaged(engagedArray));
  }, [percentVisitors, sessionDistributionWeeks, uniqueBrowsers, weeks, dispatch]);


  if (loading === 'loading') return <SingleGraphLoading />
  
  return (
    <> 
      <NumberOfUniqueVisitorsGraph
        uniqueBrowsers={uniqueBrowsers}
        engaged={uniqueEngaged}
        weeks={weeks}
        display={display}
        />
        
    </>
  )
}

export default UniqueBnDev;




